import { render } from "./searchSelect.vue?vue&type=template&id=36b21d8a"
import script from "./searchSelect.vue?vue&type=script&lang=js"
export * from "./searchSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__